import MEMBER_ROLES from '../data/constants/UserRoles'
import { TUserRole, TMemberRole } from 'src/types/common'
import { tail } from 'lodash-es'

const MEMBERSHIP_ROLES: TMemberRole[] = [
    MEMBER_ROLES.ADMIN,
    MEMBER_ROLES.AMBASSADOR,
    MEMBER_ROLES.ACTIVITY_GROUP_CONSUL,
    MEMBER_ROLES.NEWCOMER_BUDDY,
    MEMBER_ROLES.ALBATROSS,
    MEMBER_ROLES.USER,
]

export const getMembership = (userRoles: TUserRole[], roles: TMemberRole[] = MEMBERSHIP_ROLES): TMemberRole => {
    if (roles.length === 0 || !userRoles || userRoles.length === 0) {
        return 'ROLE_USER'
    }

    const [role] = roles

    return role && userRoles.includes(role) ? role : getMembership(userRoles, tail(roles))
}

const isActiveRole = (userRoles: TUserRole[], role: TUserRole): boolean => getMembership(userRoles) === role

const hasRole = (userRoles: TUserRole[], role: TUserRole): boolean =>
    userRoles && userRoles.length > 0 && userRoles.includes(role)

export const isBasicUser = (userRoles: TUserRole[]): boolean => isActiveRole(userRoles, MEMBER_ROLES.USER)

export const isAdminUser = (userRoles: TUserRole[]): boolean => hasRole(userRoles, MEMBER_ROLES.ADMIN)

export const isAmbassador = (userRoles: TUserRole[]): boolean => hasRole(userRoles, MEMBER_ROLES.AMBASSADOR)

export const isConsul = (userRoles: TUserRole[]): boolean => hasRole(userRoles, MEMBER_ROLES.ACTIVITY_GROUP_CONSUL)

export const isVolunteer = (userRoles: TUserRole[]): boolean => isAmbassador(userRoles) || isConsul(userRoles)

export const isNewcomerBuddy = (userRoles: TUserRole[]): boolean => hasRole(userRoles, MEMBER_ROLES.NEWCOMER_BUDDY)

export const isAlbatross = (userRoles: TUserRole[]): boolean => hasRole(userRoles, MEMBER_ROLES.ALBATROSS)
